// Copyright 2022-2024 - Hewlett Packard Enterprise Company
import { Box, Button, Heading, Layer, Notification, Text } from 'grommet';
import { useTranslation } from 'react-i18next';
import { StatusWarningSmall } from '../Icons/AllStatusIcons';

export default function GroupDisabledModal({ groupName, onClose }) {
  const { t } = useTranslation('common');

  return (
    <Layer
      as="section"
      position="center"
      modal
      onClickOutside={onClose}
      onEsc={onClose}
    >
      <Box gap="none" pad="medium" width="586px">
        <>
          <Heading level={2} margin="none" truncate>
            {groupName}
          </Heading>
          <Notification
            status="warning"
            icon={<StatusWarningSmall color="status-warning" size="large" />}
            message={
              <Box>
                <Text size="large">
                  {t('group_detail_page.group_disabled_modal.text')}
                </Text>
              </Box>
            }
          />
        </>
        <Box justify="end" direction="row">
          <Button
            label={t('group_detail_page.group_disabled_modal.close_btn_label')}
            onClick={onClose}
            primary
          />
        </Box>
      </Box>
    </Layer>
  );
}
